import React, { useEffect, useRef, useState } from "react";
import { Autocomplete, TextField, Chip } from "@mui/material";
import "./chip-select-ui.component.scss";
import { Button } from "react-bootstrap";

const ChipSelector = ({ label, skills, setSkills, selectedSkills, isError }) => {
    const [inputValue, setInputValue] = useState(""); // Track user input
    const [isFocused, setIsFocused] = useState(false); // Track input focus
    const [formError, setFormError] = useState(false);
    const inputRef = useRef<HTMLInputElement | null>(null); // Reference for input focus control

    useEffect(() => {
        if(isError){
            setFormError(true);
        }else{
            setFormError(false);
        }
    },[isError])
    // Handle adding skills
    const handleAddSkill = (event, newValue) => {

        if (Array.isArray(newValue)) {
            if(label.includes("Hard Skill")){
                setSkills(newValue, "hard_skill");
            }else if(label.includes("Soft Skill")){
                setSkills(newValue, "soft_skill");
            }else if(label.includes("Tech Tool")){
                setSkills(newValue, "tech_tool");
            }else if(label.includes("Culture")){
                setSkills(newValue, "culture");
            }else if(label.includes("Leadership")){
                setSkills(newValue, "leader");
            }
             // Update selected skills list
        }
    };



    // Handle focus when clicking the button
    const handleFocusInput = () => {
        setIsFocused(true);
        setTimeout(() => {
            inputRef.current?.focus(); // Focus input field
        }, 100); // Slight delay to ensure UI updates properly
    };

    // Handle blur event (clear input value but keep selected skills)
    const handleOnBlur = () => {
        setTimeout(() => {
            setIsFocused(false);
            setInputValue(""); // Clear the input value after losing focus
        }, 150); // Ensure UI update
    };

    const handleInputChange = (event, newInputValue) => {

        if (isFocused) {
            setInputValue(newInputValue)
        } else {
            console.log(newInputValue);
            setInputValue("")
        }
    }
  
    return (
        <div className="chip-selector-container">
            <Autocomplete
                multiple
                freeSolo
                id="chip-autocomplete"
                className={formError ? "input-std chip-input-control input-error": 
                    selectedSkills && selectedSkills.length > 0 ? "input-std chip-input-control have-chipped" : "input-std chip-input-control"}
                options={inputValue.length >= 3 ? skills : []} // Show suggestions only if input >= 3 chars
                value={selectedSkills} // Show selected skills as chips
                onChange={handleAddSkill}
                onInputChange={(event, newInputValue) => handleInputChange(event, newInputValue)} // Update input value
                onFocus={() => setIsFocused(true)}
                clearOnBlur
                onBlur={handleOnBlur}
                renderTags={(selectedSkills, getTagProps) => [
                    ...selectedSkills.map((skill, index) => (
                        <Chip
                            label={skill}
                            {...getTagProps({ index })} // Spread existing props correctly
                            className="chip-selected"
                            key={index}
                        />
                    )),
                    !isFocused && (
                        <Button
                            key="add-more-btn"
                            variant="outline-primary"
                            size="sm"
                            className="add-more-btn"
                            onClick={handleFocusInput}
                        >
                            + เพิ่มทักษะ
                        </Button>
                    )
                ]}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        inputRef={inputRef} // Attach ref for focusing
                        label={label} // Hide label when focused
                        value={inputValue} // Ensure input value is controlled
                    />
                )}
            />
        </div>
    );
};

export default ChipSelector;
